import {RouterModule, Routes} from "@angular/router";
import {NgModule} from "@angular/core";
import {PreviewBsiComponent} from "./preview-bsi.component";
import {LayoutComponent} from "../layout/layout.component";

const routes: Routes = [
  {
    path: 'preview-bsi',
    component: LayoutComponent,
    children: [
      {
        path: '',
        component: PreviewBsiComponent,
      }
    ]
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PreviewBsiRoutingModule { }
